import { Blog } from "../models/blog";

import Ostern from "../images/news/event_ostern.jpg";
import Fahrrad from "../images/news/fahrrad.jpg";
import Ferien from "../images/news/ferien.jpg";
import Flohmarkt from "../images/news/flohmarkt.jpg";
import Halloween from "../images/news/halloween.jpg";
import Muttertag from "../images/news/muttertag.jpg";
import Nikolaus from "../images/news/nikolaus.jpg";
import Styling from "../images/news/umstyling_aktion.jpg";
import ValentinsTag2025 from "../images/news/valentinstag.jpg";
import Fahrradtag2026 from "../images/news/2026/fahrradtag.jpg";
import Ferienbeginn2026 from "../images/news/2026/ferienbeginn.jpg";
import Halloween2026 from "../images/news/2026/halloween.jpg";
import HaustierHelden2026 from "../images/news/2026/haustier-helden.jpg";
import Muttertag2026 from "../images/news/2026/muttertag.jpg";
import Nikolaus2026 from "../images/news/2026/nikolaus.jpg";
import Spielzeugflohmarkt2026 from "../images/news/2026/spielzeugflohmarkt.jpg";
import Umstyling2026 from "../images/news/2026/umstyling.jpg";
import ValentinsTag2026 from "../images/news/2026/valentinstag.jpg";
import Vatertag2026 from "../images/news/2026/vatertag.jpg";
import Ybbsiade from "../images/news/ybsiade_neu.jpg";

const news: Blog[] = [
  {
    image: Nikolaus2026,
    date: "9 bis 15 Uhr",
    title:
      "05.12: Auf die Plätze, fertig, suchen: Der Nikolaus versteckt sich im B1!",
    sortDate: "2026-12-05",
    content: (
      <div>
        <p>
          Am <strong>Samstag, 5. Dezember 2026</strong>, wird es im B1 richtig
          spannend: Der Nikolaus hat sich versteckt – und wartet nur darauf, von
          euch gefunden zu werden!
        </p>
        <p className="mt-4">
          Seid auf der Jagd bei unserer fröhlichen Schnitzeljagd: sammelt
          Hinweise, löst knifflige Rätsel und zeigt, dass ihr echte
          Nikolaus-Detektive seid.
        </p>
        <p className="mt-4">
          Am Ende gibt’s tolle Überraschungen und ein Foto mit dem Nikolaus –
          als Beweis, dass ihr ihn wirklich gefunden habt!
        </p>
        <p className="mt-4">
          Also, detektivische Nase aufsetzen, Rätsel lösen und Nikolaus fangen –
          wir freuen uns auf euch!
        </p>
        <p className="mt-4">
          <strong>Gewinne beim B1 Glücksrad!</strong>
          <br />
          Drehe am Glücksrad und sichere Dir tolle Preise. Das Glücksrad ist ab
          sofort bei jeder Aktion dabei und immer bei einem anderen Shop im
          Center platziert – also komm ins B1 und versuch Dein Glück!
        </p>
      </div>
    ),
    excerpt:
      "Am Samstag, 5. Dezember 2026, wird es im B1 richtig spannend: Der Nikolaus hat sich versteckt – und wartet nur darauf, von euch gefunden zu werden! Seid auf der Jagd bei unserer fröhlichen Schnitzeljagd: sammelt Hinweise, löst knifflige Rätsel und zeigt, dass ihr echte Nikolaus-Detektive seid.",
  },
  {
    image: Halloween2026,
    date: "9 bis 15 Uhr",
    title: "31.10: Halloween im B1: Schminken, Geschichten & Geschenke!",
    sortDate: "2026-10-31",
    content: (
      <div>
        <p>
          Am <strong>31. Oktober 2026</strong> von 9 bis 15 Uhr verwandelt sich
          das B1 wieder in ein schaurig-schönes Abenteuerland für kleine Geister
          und ihre Familien! Das Highlight des Nachmittags: Die beliebten
          schaurigen Geschichten, die letztes Jahr so viele verzaubert haben,
          werden heuer wieder live vorgelesen – Gänsehaut garantiert!
        </p>
        <p className="mt-4">
          Jedes Kind bekommt einen Halloween-Beutel, perfekt zum Sammeln von
          Süßem – oder Saurem – und später sogar als cooler Turnbeutel nutzbar.
          Verkleidete Kinder dürfen sich über eine zusätzliche kleine
          Überraschung freuen. Und die Kinderfreunde Ybbs sorgen mit gruseligen
          Schminkkünsten für richtig furchterregende Gesichter!
        </p>
        <p className="mt-4">
          Ein Nachmittag voller Lachen, Grusel und unvergesslicher Momente
          wartet – also Kostüm an, Beutel bereit und ab ins B1!
        </p>
        <p className="mt-4">
          <strong>Gewinne beim B1 Glücksrad!</strong>
          <br />
          Drehe am Glücksrad und sichere Dir tolle Preise. Das Glücksrad ist ab
          sofort bei jeder Aktion dabei und immer bei einem anderen Shop im
          Center platziert – also komm ins B1 und versuch Dein Glück!
        </p>
      </div>
    ),
    excerpt:
      "Am 31. Oktober 2026 von 9 bis 15 Uhr verwandelt sich das B1 wieder in ein schaurig-schönes Abenteuerland für kleine Geister und ihre Familien! Das Highlight des Nachmittags: Die beliebten schaurigen Geschichten, die letztes Jahr so viele verzaubert haben, werden heuer wieder live vorgelesen – Gänsehaut garantiert!",
  },
  {
    image: Spielzeugflohmarkt2026,
    date: "9 bis 13 Uhr",
    title:
      "05.09: Tauschen, Handeln, Taschengeld verdienen: Spielzeugflohmarkt!",
    sortDate: "2026-09-05",
    content: (
      <div>
        <p>
          Nach dem großen Erfolg im letzten Jahr kommt der Spielzeugflohmarkt im
          B1 Center Ybbs zurück!
        </p>
        <p className="mt-4">
          Am <strong>Samstag, den 5. September 2026</strong>, treffen sich wieder
          kleine Händler zwischen 6 und 12 Jahren mit ihren Begleitpersonen zum
          Tauschen, Handeln, Kaufen & Verkaufen. Unter Freunden zu tauschen
          macht besonders viel Spaß – neue Lieblingsspielzeuge entdecken, alte
          Schätze weitergeben und gemeinsam handeln.
        </p>
        <p className="mt-4">
          Für eine entspannte Pause zwischendurch sorgt das Café Cocktails: ein
          Kaffee oder ein kleiner Snack, während die Kinder weiter verkaufen.
          Dank direkt angrenzendem Parkplatz ist das Event besonders praktisch
          für einen schnellen Auf- und Abbau.
        </p>
        <p className="mt-4">
          Und als kleines Highlight erhält jedes teilnehmende Kind ein
          Wachsmalstifteset mit hochwertigen, langlebigen Wachsmalstiften –
          perfekt für Schule, Freizeit oder kreative Projekte.
        </p>
        <p className="mt-4">
          Ein bunter Tag voller Spaß, Freundschaft und Taschengeld-Abenteuern
          wartet auf euch – seid wieder dabei!
        </p>
        <p className="mt-4">
          <strong>Gewinne beim B1 Glücksrad!</strong>
          <br />
          Das Glücksrad ist auch wieder mit dabei - sichere Dir tolle Preise!
        </p>
        <p className="mt-4">
          <strong>Möchtest du dich für den Spielzeugflohmarkt anmelden?</strong>
          <br />
          Dann jetzt gleich unter{" "}
          <a href="mailto:info@b1-shopping.at" className="underline">
            info@b1-shopping.at
          </a>{" "}
          anmelden und mit dabei sein; je früher die Anmeldung erfolgt, desto
          sicherer ist die Teilnahmemöglichkeit. Die Standplätze werden zur
          Verfügung gestellt und sind kostenlos. Wir bitten bei der Anmeldung um
          folgende Daten: Name des Kindes, Geburtsdatum, Name der
          Begleitperson, Telefonnummer, E-Mail-Adresse.
        </p>
        <p className="mt-4">
          Es gilt das Prinzip "first come, first serve". Wir melden uns auf
          deine Email-Anmeldung, ob es mit einem Standplatz geklappt hat. Dauer:
          9 bis 13 Uhr. Teilnahmeberechtigt sind ausnahmslos Kinder zwischen 6
          und 12 Jahre. Begrenzte Teilnehmerzahl.
        </p>
        <p className="mt-4">
          <strong>Nützliche Tipps für einen erfolgreichen Flohmarktverkauf:</strong>
        </p>
        <ul className="list-disc list-inside">
          <li className="py-1">
            <strong>Preise festlegen:</strong> Überlegt euch im Vorfeld, welchen
            Betrag ihr für euer gebrauchtes Spielzeug haben möchtet.
            Beschriftet die Artikel – das macht Preisverhandlungen einfacher.
          </li>
          <li className="py-1">
            <strong>Taschenrechner mitnehmen:</strong> Besonders bei viel Trubel
            ist ein Taschenrechner praktisch, um den Überblick zu bewahren.
          </li>
          <li className="py-1">
            <strong>Wechselgeld bereithalten:</strong> Stellt sicher, dass ihr
            genügend Kleingeld dabei habt, um reibungslos Wechselgeld geben zu
            können.
          </li>
        </ul>
        <p className="mt-4">
          <strong>Teilnahmebedingungen:</strong>
        </p>
        <ul className="list-disc list-inside">
          <li className="py-1">
            Was nicht verkauft werden darf: Kleidung, Lebensmittel, Getränke,
            Babyausstattung, Möbel, Kriegsspielzeug, lebende Tiere und
            Sportgeräte.
          </li>
          <li className="py-1">
            Teilnahmeberechtigt sind Kinder von 6 bis 12 Jahre (in Begleitung
            eines Erwachsenen).
          </li>
          <li className="py-1">
            Die Anmeldung erfolgt über ein Mail an{" "}
            <a href="mailto:info@b1-shopping.at" className="underline">
              info@b1-shopping.at
            </a>{" "}
            mit den oben genannten Details. Durch Abschicken erklärt sich
            ein(e) Erziehungsberechtigte(r) mit den Teilnahme-Bedingungen
            einverstanden.
          </li>
          <li className="py-1">
            Eine Anmeldung ist solange möglich, bis alle Plätze vergeben sind.
          </li>
          <li className="py-1">
            Erst mit der schriftlichen Zusage seitens des B1 ist deine Teilnahme
            bestätigt.
          </li>
          <li className="py-1">
            Das B1 übernimmt keine Haftung und behält sich das Recht vor den
            Spielzeugflohmarkt jederzeit abzusagen.
          </li>
        </ul>
      </div>
    ),
    excerpt:
      "Nach dem großen Erfolg im letzten Jahr kommt der Spielzeugflohmarkt im B1 Center Ybbs zurück! Am Samstag, den 5. September 2026, treffen sich wieder kleine Händler zwischen 6 und 12 Jahren mit ihren Begleitpersonen zum Tauschen, Handeln, Kaufen & Verkaufen. Unter Freunden zu tauschen macht besonders viel Spaß – neue Lieblingsspielzeuge entdecken, alte Schätze weitergeben und gemeinsam handeln.",
  },
  {
    image: Umstyling2026,
    date: "26.09.2026",
    title: "26.09: Gewinne deinen Look!",
    sortDate: "2026-09-26",
    content: (
      <div>
        <p>
          Letztes Jahr war unser Styling-Gewinnspiel ein voller Erfolg – und
          deshalb gibt es 2026 die Chance für alle Modefans wieder! Im September
          kannst du ein komplettes Umstyling im Wert von 500 Euro gewinnen:
          Outfits, Schuhe, Friseurbesuch – alles inklusive, begleitet von der
          Amstettner Stylingberaterin Claudia Weyrer im B1.
        </p>
        <p className="mt-4">
          Obendrauf gibt’s eine professionelle Farbberatung, die deinem Look den
          letzten Schliff verleiht.
        </p>
        <p className="mt-4">
          So einfach geht’s: Melde dich online unter{" "}
          <a href="mailto:info@b1-shopping.at" className="underline">
            info@b1-shopping.at
          </a>{" "}
          an oder nutze ab August die Anmeldekarten in den Shops. Verpasse
          nicht die Gelegenheit, deinen Style komplett neu zu entdecken!
        </p>
        <p className="mt-4">
          <strong>Gewinne beim B1 Glücksrad!</strong>
          <br />
          Drehe am Glücksrad und sichere Dir tolle Preise. Das Glücksrad ist ab
          sofort bei jeder Aktion dabei und immer bei einem anderen Shop im
          Center platziert – also komm ins B1 und versuch Dein Glück!
        </p>
      </div>
    ),
    excerpt:
      "Letztes Jahr war unser Styling-Gewinnspiel ein voller Erfolg – und deshalb gibt es 2026 die Chance für alle Modefans wieder! Im September kannst du ein komplettes Umstyling im Wert von 500 Euro gewinnen: Outfits, Schuhe, Friseurbesuch – alles inklusive, begleitet von der Amstettner Stylingberaterin Claudia Weyrer im B1.",
  },
  {
    image: Ferienbeginn2026,
    date: "9 bis 15 Uhr",
    title: "04.07: Ninja-Action, Eis & Spaß!",
    sortDate: "2026-07-04",
    content: (
      <div>
        <p>
          Seid dabei, wenn es im B1 Center Ybbs erstmalig heißt: Ninja-Action
          für Groß und Klein!
        </p>
        <p className="mt-4">
          Unsere Mega-Hüpfburg mit Hindernislauf bietet von 9 bis 15 Uhr jede
          Menge Spaß für die ganz kleinen Ninjas – springen, klettern, toben und
          Abenteuer erleben. Natürlich mit Betreuung, damit die Eltern entspannt
          zusehen oder selbst die Atmosphäre genießen können.
        </p>
        <p className="mt-4">
          Dazu gibt es hausgemachtes Eis vom Burgcafé Ybbs, das schon letztes
          Jahr für ausgezeichnetes Feedback gesorgt hat. Wir haben für euch
          wieder eine neue Kreation ausgedacht und hoffen, sie schmeckt euch!
          Eine perfekte Kombination aus Bewegung, Spaß und leckerem Eis.
        </p>
        <p className="mt-4">
          Das Event ist der perfekte Start in die Sommerferien – Action, Lachen
          und Genuss für die ganze Familie! Ein Event voller Abenteuer –
          Ninja-Action, die allen Freude macht!
        </p>
        <p className="mt-4">
          <strong>Gewinne beim B1 Glücksrad!</strong>
          <br />
          Drehe am Glücksrad und sichere Dir tolle Preise. Das Glücksrad ist ab
          sofort bei jeder Aktion dabei und immer bei einem anderen Shop im
          Center platziert – also komm ins B1 und versuch Dein Glück!
        </p>
      </div>
    ),
    excerpt:
      "Seid dabei, wenn es im B1 Center Ybbs erstmalig heißt: Ninja-Action für Groß und Klein! Unsere Mega-Hüpfburg mit Hindernislauf bietet von 9 bis 15 Uhr jede Menge Spaß für die ganz kleinen Ninjas – springen, klettern, toben und Abenteuer erleben.",
  },
  {
    image: Vatertag2026,
    date: "9 bis 15 Uhr",
    title: "13.06: Vollgas für alle Männer!",
    sortDate: "2026-06-13",
    content: (
      <div>
        <p>
          Am <strong>13. Juni 2026</strong> gehört das B1 Center Ybbs ganz den
          Männern – und besonders den Vätern. Von 9 bis 15 Uhr wird gedreht,
          gestaunt und genossen.
        </p>
        <p className="mt-4">
          <strong>Die Highlights auf einen Blick:</strong>
        </p>
        <ul className="list-disc list-inside">
          <li className="py-1">
            <strong>🚗 Autohaus Senker live vor Ort:</strong> Fahrzeugausstellung
            mit aktuellen E-Modellen aus dem Volkswagen Konzern. Dazu
            Mobilitätsprofi Hr. Wolfgang Burger, der alle Fragen beantwortet und
            zwei aktuelle E-Modelle direkt vor Ort präsentiert.
          </li>
          <li className="py-1">
            <strong>🎡 Glücksrad:</strong> Jeder Dreh ein Gewinn – mit kleinen
            Überraschungen und technischer Action.
          </li>
          <li className="py-1">
            <strong>🍺 Café Cocktails Special:</strong> Eine kleine
            Aufmerksamkeit für die Herren – ein kühles Bier!
          </li>
        </ul>
        <p className="mt-4">
          <strong>🎁 Geschenkidee zum Vatertag – jetzt auf Facebook mitmachen!</strong>
          <br />
          Wer seinem Papa etwas wirklich Tolles schenken will, sollte unbedingt
          vorab auf Facebook vorbeischauen: Dort warten 5 Premium-Autowäschen
          als perfektes Vatertagsgeschenk. Einfach mitmachen, mit etwas Glück
          gewinnen und dem Vater ein glänzendes Extra schenken, das garantiert
          gut ankommt.
        </p>
        <p className="mt-4">
          Vorbeikommen, entdecken und den Männertag im B1 Center Ybbs genießen –
          mit viel Action, guter Laune und einer Extraportion Glück.
        </p>
      </div>
    ),
    excerpt:
      "Am 13. Juni 2026 gehört das B1 Center Ybbs ganz den Männern – und besonders den Vätern. Von 9 bis 15 Uhr wird gedreht, gestaunt und genossen. Mit Autohaus Senker live vor Ort, Glücksrad und Café Cocktails Special.",
  },
  {
    image: HaustierHelden2026,
    date: "9 bis 15 Uhr",
    title: "23.05: Haustier-Helden!",
    sortDate: "2026-05-23",
    content: (
      <div>
        <p>
          Am <strong>Samstag, 23. Mai 2026</strong> von 9:00 bis 15:00 Uhr dreht
          sich im B1 Center Ybbs alles um unsere tierischen Begleiter: Beim
          Haustiertag erwartet Besucher:innen ein abwechslungsreiches Programm
          für Hund und Halter:innen. In Kooperation mit der Hundeschule Bergland
          wird vor Ort kostenloses Hundetraining angeboten – eine ideale
          Gelegenheit, sich Tipps von Profis zu holen oder gemeinsam mit dem
          eigenen Hund erste Übungen auszuprobieren.
        </p>
        <p className="mt-4">
          <strong>Das erwartet Sie beim Haustiertag:</strong>
        </p>
        <ul className="list-disc list-inside">
          <li className="py-1">
            🐶 Kostenloses Hundetraining mit der Hundeschule Bergland
          </li>
          <li className="py-1">
            🐕 Agility-Training vor Ort und spannende Vorführungen mit
            ausgebildeten Trainingshunden
          </li>
          <li className="py-1">
            ✂️ Hundesalon Beautydog live vor Ort
            <br />
            Mit Frau Grandegger – professionelle Hundepflege & persönliche
            Beratung entdecken!
          </li>
          <li className="py-1">
            🦴 Hundebar mit kostenloser Stärkung für alle Begleithunde
          </li>
          <li className="py-1">
            🎁 Facebook-Verlosung: Gutschein für 2 Personen + 1 Nacht mit Hund
            im Hotel Das Eisenberg – Verlosung folgt, bleibt wachsam! 😊
          </li>
          <li className="py-1">
            🍪 Hundekeks-Ausstechform inklusive Rezept für selbstgemachte
            Hundeknochen zum Mitnehmen
          </li>
          <li className="py-1">
            🎡 Glücksrad vor der Fressnapf-Filiale mit Überraschungen für alle
            Hundehalter:innen
          </li>
        </ul>
        <p className="mt-4">
          Ein Besuch lohnt sich außerdem bei Fressnapf, Pets Royal, dm oder KiK
          im Center – auch dort warten spannende Angebote und Aktionen rund um
          das Thema Haustier.
        </p>
        <p className="mt-4">
          Der Haustiertag im B1 Center Ybbs bietet damit die perfekte
          Gelegenheit, gemeinsam mit dem eigenen Hund einen erlebnisreichen Tag
          zu verbringen, Neues zu lernen und tolle Preise zu gewinnen. Wir
          freuen uns auf Ihren Besuch! 🐾
        </p>
      </div>
    ),
    excerpt:
      "Am Samstag, 23. Mai 2026 von 9:00 bis 15:00 Uhr dreht sich im B1 Center Ybbs alles um unsere tierischen Begleiter: Beim Haustiertag erwartet Besucher:innen ein abwechslungsreiches Programm für Hund und Halter:innen. In Kooperation mit der Hundeschule Bergland wird vor Ort kostenloses Hundetraining angeboten.",
  },
  {
    image: Muttertag2026,
    date: "9 bis 15 Uhr",
    title: "09.05: Mama, heute bist DU dran!",
    sortDate: "2026-05-09",
    content: (
      <div>
        <p>
          Am <strong>Samstag, 9. Mai 2026</strong>, gibt es im B1 Center Ybbs
          etwas ganz Besonderes zum Muttertag: kostenlose Kinderbetreuung von 9
          bis 15 Uhr durch die Kinderfreunde Niederösterreich!
        </p>
        <p className="mt-4">
          Während die Kinder mit Jongliermaterial und kreativen Angeboten
          bestens beschäftigt sind, können Mamas sich endlich eine verdiente
          Auszeit gönnen. Shoppen, im Café einen Cocktail genießen,
          Freundinnen treffen oder einen Friseurtermin wahrnehmen – heute geht
          alles! Und als kleines Dankeschön wartet auf jede Besucherin ein Glas
          Prosecco. 🥂
        </p>
        <p className="mt-4">
          Liebe Mamas, wir sehen, wieviel ihr leistet. Genießt ein paar Stunden
          nur für euch – und nehmt am besten noch eine Freundin mit!
        </p>
        <p className="mt-4">
          <strong>Gewinne beim B1 Glücksrad!</strong>
          <br />
          Drehe am Glücksrad und sichere Dir tolle Preise. Das Glücksrad ist ab
          sofort bei jeder Aktion dabei und immer bei einem anderen Shop im
          Center platziert – also komm ins B1 und versuch Dein Glück!
        </p>
      </div>
    ),
    excerpt:
      "Am Samstag, 9. Mai 2026, gibt es im B1 Center Ybbs etwas ganz Besonderes zum Muttertag: kostenlose Kinderbetreuung von 9 bis 15 Uhr durch die Kinderfreunde Niederösterreich. Während die Kinder mit kreativen Angeboten bestens beschäftigt sind, können Mamas sich eine verdiente Auszeit gönnen – inklusive Prosecco als kleines Dankeschön.",
  },
  {
    image: Fahrradtag2026,
    date: "9 bis 15 Uhr",
    title: "25.04: Aufsteigen und los! Kostenloses Radfahrtraining für Kinder",
    sortDate: "2026-04-25",
    content: (
      <div>
        <p>
          Am <strong>Samstag, 25. April 2026</strong>, von 9 bis 15 Uhr, heißt
          es wieder: Sicher unterwegs auf zwei Rädern! Nach dem großen Erfolg im
          letzten Jahr findet das Radfahrtraining für Kinder erneut im B1 Center
          Ybbs statt.
        </p>
        <p className="mt-4">
          In Kooperation mit FahrSicherRad – der Radfahrschule trainieren zwei
          professionelle Radfahrtrainer*innen mit den Kindern auf einem
          abgetrennten Parcours am Parkplatz. Mit Geschicklichkeitsspielen,
          praxisnahen Übungen und viel Spaß lernen junge Radfahrer*innen
          sicheres Verhalten im Straßenverkehr. Als Abschluss gibt es eine
          Medaille für jedes Kind und als langlebiges Geschenk eine
          Kinder-Warnweste. Leihräder, Helme und Roller stehen vor Ort zur
          Verfügung – alternativ kann auch das eigene Fahrrad mitgebracht werden.
        </p>
        <p className="mt-4">
          Zusätzlich wird die Polizei von 12 bis 15 Uhr vor Ort sein und mit
          zwei Beamt*innen die Veranstaltung begleiten. Dabei steht insbesondere
          ein speziell in der Verkehrserziehung ausgebildeter Fahrradpolizist
          als kompetenter Ansprechpartner für Fragen rund um sicheres Radfahren
          zur Verfügung.
        </p>
        <p className="mt-4">
          <strong>Gewinne beim B1 Glücksrad!</strong>
          <br />
          Drehe am Glücksrad und sichere Dir tolle Preise. Das Glücksrad ist ab
          sofort bei jeder Aktion dabei und immer bei einem anderen Shop im
          Center platziert – also komm ins B1 und versuch Dein Glück!
        </p>
        <p className="mt-4">
          👉 Mitmachen, lernen und sicher radeln im B1 Center Ybbs!
        </p>
      </div>
    ),
    excerpt:
      "Am Samstag, 25. April 2026, von 9 bis 15 Uhr, heißt es wieder: Sicher unterwegs auf zwei Rädern! Nach dem großen Erfolg im letzten Jahr findet das Radfahrtraining für Kinder erneut im B1 Center Ybbs statt. In Kooperation mit FahrSicherRad – der Radfahrschule trainieren zwei professionelle Radfahrtrainer*innen mit den Kindern auf einem abgetrennten Parcours am Parkplatz.",
  },
  {
    image: ValentinsTag2026,
    date: "10 bis 16 Uhr",
    title: "14.02: Süß. Knackig. Valentinstag.",
    sortDate: "2026-02-14",
    content: (
      <div>
        Am <strong>Samstag, den 14. Februar 2026</strong>, laden wir euch von 10
        bis 16 Uhr im B1 Center Ybbs zu einem kleinen Valentinszauber ein: Freut
        euch auf liebevoll verpackte Nusssackerl von der Nussland GmbH aus
        Dollbach. Zum Valentinstag geht es darum, Menschen, die man mag, eine
        Freude zu bereiten – und genau das möchten wir für euch tun! Dazu gibt
        es ein prickelndes Glas Sekt, serviert im Café Cocktails. Genießt die
        regionalen Köstlichkeiten, die herzliche Atmosphäre und ein kleines
        Stück Freude mitten im Herzen unserer Region. Wir freuen uns sehr
        darauf, diesen besonderen Tag mit euch zu feiern! (Nusssackerl und
        Prosecco solange der Vorrat reicht.)
      </div>
    ),
    excerpt:
      "Am Samstag, den 14. Februar 2026, laden wir euch von 10 bis 16 Uhr im B1 Center Ybbs zu einem kleinen Valentinszauber ein: Freut euch auf liebevoll verpackte Nusssackerl von der Nussland GmbH aus Dollbach. Zum Valentinstag geht es darum, Menschen, die man mag, eine Freude zu bereiten – und genau das möchten wir für euch tun!",
  },
].sort((a, b) => (b.sortDate ?? "").localeCompare(a.sortDate ?? ""));

export const newsArchive2025: Blog[] = [
  {
    image: ValentinsTag2025,
    date: "10 bis 16 Uhr",
    title: "14.02: Dein Valentinstag!",
    sortDate: "2025-02-14",
    content: (
      <div>
        Am <strong>Freitag, den 14. Februar</strong> erwartet euch im B1 Center
        Valentinstagsstimmung pur! Von 10 bis 16 Uhr gibt’s exklusive,
        handgemachte Valentinsherzen der Bäckerei Weinberger, gefüllt mit
        Nougatcreme und regionaler Dirndlmarmelade. Im "Cocktails" laden wir
        euch auf ein Glas Prosecco ein – perfekt für prickelnde Momente! Noch
        kein Geschenk? In unseren Geschäften findet ihr sicher das Passende.
        Kommt vorbei und feiert mit uns den Tag der Liebe!
      </div>
    ),
    excerpt:
      'Am Freitag, den 14. Februar erwartet euch im B1 Center Valentinstagsstimmung pur! Von 10 bis 16 Uhr gibt’s exklusive, handgemachte Valentinsherzen der Bäckerei Weinberger, gefüllt mit Nougatcreme und regionaler Dirndlmarmelade. Im "Cocktails" laden wir euch auf ein Glas Prosecco ein – perfekt für prickelnde Momente! Noch kein Geschenk? In unseren Geschäften findet ihr sicher das Passende. Kommt vorbei und feiert mit uns den Tag der Liebe!',
  },
  {
    image: Fahrrad,
    date: "10 bis 16 Uhr",
    title: "08.03: Rauf aufs Rad! Kostenloses Radfahrtraining für Kinder!",
    sortDate: "2025-03-08",
    content: (
      <>
        <div>
          Am Samstag, den 8. März heißt es im B1 Center Ybbs: „Rauf aufs Rad!“
          Kinder von 4 bis 10 Jahren sind eingeladen, zwischen 10 und 16 Uhr auf
          einem abgesperrten Parcours ihre Radfahrkünste zu trainieren. Die
          Profis der Mostviertler Radschule „Radeln macht Schule“ zeigen den
          Kleinen spielerisch sicheres Radfahren. Einfach eigenes Rad und Helm
          mitbringen – keine Voranmeldung nötig. Als Belohnung gibt’s am Ende
          für jedes Kind eine Medaille und einen minus 50%-Gutschein* für einen
          professeionellen Sicherheitscheck von Posh cycling in Ybbs.. Ein
          besonderes Highlight: Zur Feier der kleinen FahrradheldInnen gibt es
          den eigens kreierten Kindercocktail „Florida Sun“ für nur € 4 im
          Cocktails! Ein tolles Event für alle kleinen Radfans!
        </div>
        <div className="text-xs mt-2">
          *50% Gutschein für den Sicherheitscheck – gültig bis 31.08.2025. Mit
          diesem Gutschein erhältst du einen umfassenden Sicherheitscheck für
          das Fahrrad deines Kindes, das an unserer Veranstaltung teilgenommen
          hat. Der Check umfasst: Bremsenprüfung und -einstellung, Überprüfung
          und Einstellung des Steuersatzes, Schaltungseinstellung. Der Wert des
          Checks beträgt regulär € 40,–. Wichtig: Eventuell benötigte
          Verschleißteile, wie z. B. Bremsbeläge, werden separat verrechnet. Der
          Gutschein ist nur gültig für das Fahrrad, mit dem dein Kind an der
          Veranstaltung teilgenommen hat. Der Gutschein kann nur in Verbindung
          mit der bei der Veranstaltung erworbenen Medaille eingelöst werden.
        </div>
      </>
    ),
    excerpt: `Am Samstag, den 8. März heißt es im B1 Center Ybbs: „Rauf aufs Rad!“ Kinder von 4 bis 10 Jahren sind eingeladen, zwischen 10 und 16 Uhr auf einem abgesperrten Parcours ihre Radfahrkünste zu trainieren. Die Profis der Mostviertler Radschule „Radeln macht Schule“ zeigen den Kleinen spielerisch sicheres Radfahren`,
  },
  {
    image: Ybbsiade,
    date: "",
    title: "30.04: Nachbarschaftsliebe: B1 und die Ybbsiade!",
    sortDate: "2025-04-30",
    content: (
      <div>
        <p>
          Am 30. April erwartet uns ein ganz besonderer Abend: Bei unseren
          Nachbarn am Busterminal Mitterbauer, findet eine Vorstellung der
          Ybbsiade statt! Das Lastkrafttheater kommt mit dem Stück „Pension
          Schöller“ (von Carl Laufs und Wilhelm Jacoby). Wir freuen uns riesig,
          dass dieses wunderbare Kulturfestival unsere Region bereichert, und
          möchten diesen Anlass gemeinsam mit euch feiern.
        </p>
        <p className="mt-4">
          Deshalb laden wir alle Besucherinnen und Besucher der Ybbsiade und des
          B1 herzlich auf ein Glas Prosecco ins Cocktails ein. Noch besser: Wer
          als Ybbsiade-Gast sein Auto bei uns auf dem B1-Parkplatz abstellen
          möchte, kann dies ganz bequem und kostenfrei tun.
        </p>
        <p className="mt-4">
          Und falls ihr keine Tickets für die Vorstellung ergattert habt, gibt
          es trotzdem gute Gründe, uns zu besuchen: Die Shops im B1 haben an
          diesem Tag tolle Aktionen und spezielle Angebote für euch vorbereitet.
        </p>
        <p className="mt-4">
          Wir wünschen allen einen wundervollen Abend voller Kultur, Genuss und
          guter Stimmung. Tickets unter www.ybbsiade.at
        </p>
      </div>
    ),
    excerpt:
      "Am 30. April erwartet uns ein ganz besonderer Abend: Bei unseren Nachbarn am Busterminal Mitterbauer, findet eine Vorstellung der Ybbsiade statt! Das Lastkrafttheater kommt mit dem Stück „Pension Schöller“ (von Carl Laufs und Wilhelm Jacoby). Wir freuen uns riesig, dass dieses wunderbare Kulturfestival unsere Region bereichert, und möchten diesen Anlass gemeinsam mit euch feiern. Deshalb laden wir alle Besucherinnen und Besucher der Ybbsiade und des B1 herzlich auf ein Glas Prosecco ins Cocktails ein.",
  },
  {
    image: Ostern,
    date: "10 bis 16 Uhr",
    title: "12.04: Osterkunst aus Kinderhand: Bunte Ei-Unikate!",
    sortDate: "2025-04-12",
    content: (
      <div>
        Kleine Kinder, große Künstler! Am Samstag, den 12. April, wartet im B1
        Center Ybbs eine besondere Osterüberraschung: Alle BesucherInnen
        erhalten ein handbemaltes Osterei. Die kunstvollen Unikate wurden von
        den Kindern der beiden Kindergärten der Stadt Ybbs mit viel Liebe
        verziert. Als Dankeschön für die tatkräftige Unterstützung wird eine
        großzügige Spende an die Stadt für die Kindergärten überreicht. So
        profitieren die KünstlerInnen direkt von diesem Engagement! Die Aktion
        soll nicht nur Freude bereiten, sondern auch die Fantasie und den
        Gestaltungsgeist der Kinder in den Mittelpunkt rücken. (Von 10 bis 16
        Uhr – solange der Vorrat reicht.)
      </div>
    ),
    excerpt:
      "Kleine Kinder, große Künstler! Am Samstag, den 12. April, wartet im B1 Center Ybbs eine besondere Osterüberraschung: Alle BesucherInnen erhalten ein handbemaltes Osterei. Die kunstvollen Unikate wurden von den Kindern der beiden Kindergärten der Stadt Ybbs mit viel Liebe verziert.",
  },
  {
    image: Muttertag,
    date: "10 bis 16 Uhr",
    title: "10.05: Tag der 1.000 Küsse!",
    sortDate: "2025-05-10",
    content: (
      <div>
        Am Samstag, den 10. Mai, lädt das B1 Center Ybbs im Rahmen des
        Muttertags zwischen 10 und 16 Uhr zum kostenlosen Fotoshooting ein! Komm
        mit deinem Lieblingsmenschen vorbei und haltet eure herzlichen Momente
        fest. Unser Ziel: 1.000 Küsse, Umarmungen und liebevolle Augenblicke!
        Zeig uns die Person, der du „Ich hab dich lieb“ sagen möchtest. Das
        Beste: Euer Foto könnt ihr gleich mitnehmen. Ein unvergesslicher Moment
        der Zuneigung, den ihr für immer behalten werdet!
      </div>
    ),
    excerpt:
      "Am Samstag, den 10. Mai, lädt das B1 Center Ybbs im Rahmen des Muttertags zwischen 10 und 16 Uhr zum kostenlosen Fotoshooting ein! Komm mit deinem Lieblingsmenschen vorbei und haltet eure herzlichen Momente fest. Unser Ziel: 1.000 Küsse, Umarmungen und liebevolle Augenblicke! Zeig uns die Person, der du „Ich hab dich lieb“ sagen möchtest. Das Beste: Euer Foto könnt ihr gleich mitnehmen. Ein unvergesslicher Moment der Zuneigung, den ihr für immer behalten werdet!",
  },

  {
    image: Ferien,
    date: "10 bis 14 Uhr",
    title:
      "28.06: Eiskugel trifft Hüpfspaß! Gratis Eis, Hüpfburg und Shots für Groß und Klein!",
    sortDate: "2025-06-28",
    content: (
      <div>
        Am Samstag, den 28. Juni, wird der Ferienbeginn im B1 ganz groß
        gefeiert! Zum Start in die schönste Zeit des Jahres gibt’s für jeden
        eine kostenlose Kugel Eis – und nicht irgendein Eis: Sondern eine
        exklusive, hausgemachte Eissorte, entwickelt nur für das B1 Center vom
        beliebten Ybbser Eissalon Burgcafé. Hergestellt mit regionalen Zutaten –
        ein einzigartiger Genuss, den du nur hier probieren kannst.
        Sommerfeeling garantiert! <br /> Auch die Erwachsenen dürfen sich
        freuen: Im Cocktails wartet ein erfrischender Erdbeer-Shot – perfekt, um
        entspannt in den Ferienmodus zu schalten. (Eis und Shots solange der
        Vorrart reicht!)
        <br />
        Für die Kleinen gibt’s von 10 bis 14 Uhr eine riesige Hüpfburg, auf der
        sie nach Herzenslust toben können. Dazu: Urlaubsfeeling pur mit coolen
        Getränken und entspannter Musik – nur im B1 Center. Komm vorbei und
        feier mit!
      </div>
    ),
    excerpt:
      "Am Samstag, den 28. Juni, wird der Ferienbeginn im B1 ganz groß gefeiert! Zum Start in die schönste Zeit des Jahres gibt’s für jeden eine kostenlose Kugel Eis – und nicht irgendein Eis: Sondern eine exklusive, hausgemachte Eissorte, entwickelt nur für das B1 Center vom beliebten Ybbser Eissalon Burgcafé. Hergestellt mit regionalen Zutaten – ein einzigartiger Genuss, den du nur hier probieren kannst.",
  },
  {
    image: Flohmarkt,
    date: "10 bis 13 Uhr",
    title: "30.08: Kleine Händler ganz groß: Spielzeugflohmarkt!",
    sortDate: "2025-08-30",
    content: (
      <div>
        <p>
          Am Samstag, den 30. August wird das B1 zum Spielzeugparadies für
          Kinder zwischen 6 und 12 Jahren! Beim Spielzeugflohmarkt können Kinder
          von 10 bis 13 Uhr nach Herzenslust tauschen, handeln, kaufen und
          verkaufen – und das Beste: Sie können ihr Taschengeld aufbessern! Mit
          einer Begleitperson im Schlepptau wird das Stöbern und Feilschen
          garantiert zum großen Spaß.
        </p>
        <p className="mt-4">
          Neben tollen Spielsachen gibt es auch praktische Überraschungen:
          Rechtzeitig vor Schulbeginn werden kostenlose Federpennale verteilt –
          für den perfekten Start ins neue Schuljahr! Wer noch mehr braucht,
          wird in den Geschäften des B1 fündig. Ein unvergesslicher Tag für
          kleine Händler und große Schnäppchenjäger!
        </p>

        <p className="mt-4">
          <strong>Möchtest du dich für den Spielzeugflohmarkt anmelden?</strong>{" "}
          <br />
          Dann jetzt gleich unter{" "}
          <a href="mailto:info@b1-shopping.at" className="underline">
            info@b1-shopping.at
          </a>{" "}
          anmelden und mit dabei sein; je früher die Anmeldung erfolgt, desto
          sicherer ist die Teilnahmemöglichkeit. Die Standplätze sind kostenlos.
          Wir bitten bei der Anmeldung um folgende Daten: Name des Kindes,
          Geburtsdatum, Name der Begleitperson, Telefonnummer, E-Mail-Adresse.
          <br />
          <br />
          Es gilt das Prinzip "first come, first serve". Wir melden uns auf
          deine Email-Anmeldung, ob es mit einem Standplatz geklappt hat. Dauer:
          10 bis 13 Uhr. Teilnahmeberechtigt sind ausnahmslos Kinder zwischen 6
          und 12 Jahren. Begrenzte Teilnehmerzahl.
        </p>

        <p className="mt-4">
          <strong>
            Nützliche Tipps für einen erfolgreichen Flohmarktverkauf:
          </strong>{" "}
        </p>
        <ul className="list-disc list-inside">
          <li className="py-1">
            <strong>Preise festlegen:</strong> Überlegt euch im Vorfeld, welchen
            Betrag ihr für euer gebrauchtes Spielzeug haben möchtet. Beschriftet
            die Artikel – das macht Preisverhandlungen einfacher.
          </li>

          <li className="py-1">
            <strong>Taschenrechner mitnehmen:</strong> Besonders bei viel Trubel
            ist ein Taschenrechner praktisch, um den Überblick zu bewahren.
          </li>

          <li className="py-1">
            <strong>Wechselgeld bereithalten:</strong> Stellt sicher, dass ihr
            genügend Kleingeld dabei habt, um reibungslos Wechselgeld geben zu
            können.
          </li>
        </ul>

        <p className="mt-4">
          <strong>Teilnahmebedingungen:</strong>
          <br />
        </p>
        <ul className="list-disc list-inside">
          <li className="py-1">
            Was nicht verkauft werden darf: Kleidung, Lebensmittel, Getränke,
            Babyausstattung, Möbel, Kriegsspielzeug, lebende Tiere und
            Sportgeräte.
          </li>
          <li className="py-1">
            Teilnahmeberechtigt sind Kinder von 6 bis 12 Jahren (in Begleitung
            eines Erwachsenen).
          </li>
          <li className="py-1">
            Die Anmeldung erfolgt über ein Mail an{" "}
            <a href="mailto:info@b1-shopping.at">info@b1-shopping.at</a> mit den
            oben genannten Details. Durch das Abschicken erklärt sich ein(e)
            Erziehungsberechtigte(r) mit den Teilnahme-Bedingungen
            einverstanden.
          </li>
          <li className="py-1">
            Eine Anmeldung ist bis spätestens 14.08.2025 möglich, sofern noch
            Plätze verfügbar sind.
          </li>
          <li className="py-1">
            Erst mit der schriftlichen Zusage seitens des B1 ist deine Teilnahme
            bestätigt.
          </li>
          <li className="py-1">
            Das B1 übernimmt keine Haftung und behält sich das Recht vor den
            Spielzeugflohmarkt jederzeit abzusagen.
          </li>
        </ul>
      </div>
    ),
    excerpt:
      "Am Samstag, den 30. August wird das B1 zum Spielzeugparadies für Kinder zwischen 6 und 12 Jahren! Beim Spielzeugflohmarkt können Kinder von 10 bis 13 Uhr nach Herzenslust tauschen, handeln, kaufen und verkaufen – und das Beste: Sie können ihr Taschengeld aufbessern! Mit einer Begleitperson im Schlepptau wird das Stöbern und Feilschen garantiert zum großen Spaß. Neben tollen Spielsachen gibt es auch praktische Überraschungen: Rechtzeitig vor Schulbeginn werden kostenlose Federpennale verteilt – für den perfekten Start ins neue Schuljahr! Wer noch mehr braucht, wird in den Geschäften des B1 fündig. Ein unvergesslicher Tag für kleine Händler und große Schnäppchenjäger!",
  },

  {
    image: Styling,
    date: "20.09.2025, vormittags",
    title: "Umstyling gewinnen! Inklusive Shoppingbudget von 700 Euro!",
    sortDate: "2025-09-20",
    content: (
      <>
        <div>
          Im September wartet auf dich die Chance auf ein exklusives
          VIP-Umstyling im B1 Center Ybbs – mit professioneller Begleitung einer
          Stylingberaterin und einem Shoppingbudget von 700 Euro!
          <br />
          An deiner Seite: Mag. Claudia Weyrer – zertifizierte Farb- und
          Stilberaterin sowie Visagistin. Sie begleitet dich durch dein
          Umstyling und sorgt dafür, dass dein neuer Look perfekt zu dir passt.
        </div>
        <div className="mt-4">
          Was erwartet dich?
          <ul className="list-disc list-inside">
            <li>
              👠 Exklusive-Shoppingtour mit Mag. Claudia Weyrer, die dir zeigt,
              wie du deinen persönlichen Traumstyle findest (Termin: 20.09.2025,
              vormittags)
            </li>
            <li>
              💶 700 Euro Shoppingbudget für dein neues Outfit, Schuhe &
              Accessoires
            </li>
            <li>
              💇‍♀️ Tolle Frisur von KLIPP – kostenlos gestylt vom Profi-Team
            </li>
            <li>
              🎨 Individuelle Farbberatung mit Expertin Mag. Claudia Weyrer
            </li>
            <li>
              📸 Vorher-Nachher-Fotos & besondere Erinnerungen an deinen neuen
              Look
            </li>
            <li>
              🥂 Ein Glas Prosecco als stilvoller Abschluss deines
              Umstyling-Erlebnisses
            </li>
          </ul>
        </div>
        <div className="mt-4">
          Wie kannst du teilnehmen?
          <br />
          Ganz einfach: Schicke bis 15.09.2025 eine E-Mail an{" "}
          <a href="mailto:info@b1-shopping.at">info@b1-shopping.at</a> mit
          folgenden Angaben:
          <ul className="list-disc list-inside">
            <li>Vor- und Nachname</li>
            <li>Telefonnummer</li>
            <li>Ein aktuelles Foto von dir</li>
          </ul>
          <br />
          Unter allen Einsendungen wird eine Gewinnerin oder ein Gewinner
          ausgelost. Der/die GewinnerIn wird telefonisch verständigt und es
          werden alle Details besprochen. Die Gewinnerin oder der Gewinner darf
          sich auf eine exklusive VIP-Shoppingtour mit unserer Mag. Claudia
          Weyrer – zertifizierte Farb- und Stilberaterin sowie Visagistin
          –freuen. Klipp sorgt kostenlos für die perfekte Frisur, und ein
          Shoppingbudget von 700 Euro rundet das Styling-Erlebnis ab.
        </div>
        <div className="mt-4">
          📸 Wichtig zu wissen:
          <ul className="list-disc list-inside">
            <li>
              Das Umstyling findet am Samstag, den 20. September 2025,
              vormittags im B1 Center Ybbs statt. Du solltest daher an diesem
              Termin Zeit haben. Wir haben für dich bereits alle ExpertInnen
              organisiert – es wird ein besonderer Tag!
            </li>
            <li>
              Fotoaufnahmen während der Shoppingtour, der Gewinnübergabe sowie
              Vorher-Nachher-Bilder dürfen für Marketing- und
              Kommunikationszwecke verwendet werden (ohne Vergütung, zeitlich
              unbegrenzt).
            </li>
            <li>
              Wenn du möchtest, kann du gerne eine Begleitperson mitnehmen.
            </li>
            <li>
              Die Gewinnerin oder der Gewinner wird telefonisch verständigt und
              auf Facebook sowie der B1-Website mit Vorname, Anfangsbuchstabe
              des Nachnamens und Wohnort veröffentlicht.
            </li>
            <li>
              Mit deiner Teilnahme erklärst du dich einverstanden, dass deine
              personenbezogenen Daten zur Durchführung der Aktion verarbeitet
              werden.
            </li>
          </ul>
          <br />
          Jetzt bewerben, Styling gewinnen und mit neuem Look durchstarten – wir
          drücken die Daumen!
          <br />
          <br />
          <div className="mt-4 text-xs">
            Datenschutz & Teilnahmebedingungen
            <ul>
              <li>
                1. Veranstalter: Veranstalter des Gewinnspiels ist das B1 Center
                Ybbs.
              </li>

              <li>
                2. Teilnahmebedingungen: Teilnahmeberechtigt sind alle
                natürlichen Personen ab 18 Jahren mit Wohnsitz in Österreich.
                Die Teilnahme ist kostenlos und unabhängig von einem Einkauf.
                Pro Person ist nur eine Teilnahme zulässig. Der Rechtsweg ist
                ausgeschlossen. Der Gewinn ist nicht übertragbar und kann nicht
                in bar abgelöst werden.
              </li>

              <li>
                3. Ablauf des Gewinnspiels: Teilnahmezeitraum: bis 15.09.2025 um
                23:39 Uhr Gewinnziehung am 16.09.2025 unter Ausschluss der
                Öffentlichkeit per Losverfahren. Bekanntgabe des/der
                Gewinners/in: telefonisch sowie auf der B1-Website und
                Facebook-Seite mit Vorname, Anfangsbuchstabe des Nachnamens und
                Wohnort. Stylingtour findet am 20.09.2025, vormittags im B1
                Center Ybbs statt. Der/die GewinnerIn wird telefonisch über den
                Ablauf informiert.
              </li>

              <li>
                4. Datenschutz: Die im Rahmen des Gewinnspiels erhobenen
                personenbezogenen Daten (Name, Telefonnummer, Foto,
                E-Mail-Adresse) werden ausschließlich zur Durchführung dieses
                Gewinnspiels verarbeitet. Mit der Teilnahme erklären sich die
                Teilnehmenden damit einverstanden. Die Einwilligung zur
                Verarbeitung kann jederzeit per E-Mail an info@b1-shopping.at
                widerrufen werden. Im Falle eines Widerrufs ist die Teilnahme am
                Gewinnspiel bzw. die Gewinnannahme nicht mehr möglich.
              </li>

              <li>
                5. Foto- & Mediennutzung: Mit Teilnahme erklärst du dich
                einverstanden, dass während des Umstylings sowie der
                Shoppingtour Foto- und Videoaufnahmen gemacht werden. Diese
                dürfen vom B1 Center unentgeltlich, zeitlich unbegrenzt und
                medienübergreifend für Marketing- und Kommunikationszwecke
                verwendet werden (z. B. Website, Social Media, Print).
              </li>

              <li>
                6. Ausschluss vom Gewinnspiel: Das B1 Center behält sich das
                Recht vor, TeilnehmerInnen bei Verstoß gegen die
                Teilnahmebedingungen oder Manipulationsverdacht vom Gewinnspiel
                auszuschließen.
              </li>

              <li>
                7. Haftungsausschluss: Das B1 Center übernimmt keine Haftung für
                technische Probleme, die eine Teilnahme am Gewinnspiel
                verhindern. Für Schäden, die durch die Annahme oder Nutzung des
                Gewinns entstehen, wird keine Haftung übernommen, soweit
                gesetzlich zulässig. Rechtsweg ausgeschlossen. Druck- und
                Satzfehler vorbehalten.
              </li>

              <li>
                8. Keine Verbindung zu Facebook: Dieses Gewinnspiel steht in
                keiner Verbindung zu Facebook und wird in keiner Weise von
                diesen gesponsert, unterstützt oder organisiert.
              </li>
            </ul>
          </div>
        </div>
      </>
    ),
    excerpt:
      "Im September wartet auf dich die Chance auf ein exklusives VIP-Umstyling im B1 Center Ybbs – mit professioneller Begleitung einer Stylingberaterin und einem Shoppingbudget von 700 Euro! An deiner Seite: Mag. Claudia Weyrer – zertifizierte Farb- und Stilberaterin sowie Visagistin. Sie begleitet dich durch dein Umstyling und sorgt dafür, dass dein neuer Look perfekt zu dir passt.",
  },
  {
    image: Halloween,
    date: "13 bis 17 Uhr",
    title: "31.10: Halloween im B1: Schminken, Geschichten & Geschenke!",
    sortDate: "2025-10-31",
    content: (
      <div>
        Am 31. Oktober lädt das B1 von 13 bis 17 Uhr zum Halloween-Nachmittag
        für kleine Geister und ihre Familien! Jedes Kind erhält einen
        Halloween-Beutel zum Sammeln von Süßem oder Saurem, der später als
        Turnbeutel genutzt werden kann. Verkleidete Kinder bekommen zusätzlich
        eine kleine Überraschung, und die Kinderfreunde Ybbs schminken gruselige
        Gesichter. Wer es noch spannender mag, kann den schaurigen Geschichten
        lauschen, die im "Cocktails" vorgelesen werden. Ein Nachmittag voller
        Spaß und unvergesslicher Erlebnisse wartet!
      </div>
    ),
    excerpt:
      'Am 31. Oktober lädt das B1 von 13 bis 17 Uhr zum Halloween-Nachmittag für kleine Geister und ihre Familien! Jedes Kind erhält einen Halloween-Beutel zum Sammeln von Süßem oder Saurem, der später als Turnbeutel genutzt werden kann. Verkleidete Kinder bekommen zusätzlich eine kleine Überraschung, und die Kinderfreunde Ybbs schminken gruselige Gesichter. Wer es noch spannender mag, kann den schaurigen Geschichten lauschen, die im "Cocktails" vorgelesen werden. Ein Nachmittag voller Spaß und unvergesslicher Erlebnisse wartet!',
  },
  {
    image: Nikolaus,
    date: "10 bis 16 Uhr",
    title:
      "06.12: Auf die Plätze, fertig, suchen: Der Nikolaus versteckt sich im B1!",
    sortDate: "2025-12-06",
    content: (
      <div>
        Am Samstag, den 6. Dezember, wird es im B1 spannend: Der Nikolaus hat
        sich zwischen 10 und 16 Uhr versteckt und wartet darauf, von euch
        gefunden zu werden! Macht mit bei einer fröhlichen Schnitzeljagd,
        sammelt Hinweise und löst knifflige Rätsel. Am Ende wartet der Nikolaus
        mit tollen Überraschungen und einem Foto auf euch. Kommt vorbei – wir
        freuen uns auf euch!
      </div>
    ),
    excerpt:
      "Am Samstag, den 6. Dezember, wird es im B1 spannend: Der Nikolaus hat sich zwischen 10 und 16 Uhr versteckt und wartet darauf, von euch gefunden zu werden! Macht mit bei einer fröhlichen Schnitzeljagd, sammelt Hinweise und löst knifflige Rätsel. Am Ende wartet der Nikolaus mit tollen Überraschungen und einem Foto auf euch. Kommt vorbei – wir freuen uns auf euch!",
  },
].sort((a, b) => (b.sortDate ?? "").localeCompare(a.sortDate ?? ""));

export default news;
